module.exports = __webpack_public_path__ + "img/40_69_007_780.6cbe96b4.jpg";